import React from 'react';
import './StoryCard.css';

const StoryCard = ({ quote, author, business, className = '' }) => {
  const classes = ['story-card', className].filter(Boolean).join(' ');

  return (
    <article className={classes}>
      <p className="story-card__quote">{quote}</p>
      <div className="story-card__meta">
        <span className="story-card__author">{author}</span>
        <span className="story-card__business">{business}</span>
      </div>
    </article>
  );
};

export default StoryCard;
